var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import commonImageUploader from '../../components/console-common/common-image-uploader.vue';
import addCompany from '../../components/console-common/add-company.vue';
import colorSelect from '../../components/console-common/color-select.vue';
import * as constant from '../../constant/common-type';
import selectCustom from '../../components/console-common/select-custom.vue';
import searchInput from '../../components/console-common/search-input.vue';
import selfTextarea from '../../components/console-common/common-textarea.vue';
import { mapState } from 'vuex';
import { checkName } from '../../utils/common-utils';
import eventBus from '../../utils/fresh-table';
export default Vue.extend({
    created: function () {
        this.$store.dispatch('info/GET_COMPANY_ALL', {
            type: 'SIGN',
            loadingControl: 'hand',
        });
    },
    components: {
        'el-image-uploader': commonImageUploader,
        'el-add-company': addCompany,
        'el-color-select': colorSelect,
        'el-select-custom': selectCustom,
        'el-search-input': searchInput,
        'el-self-textarea': selfTextarea,
    },
    data: function () {
        return {
            constant: constant,
            purposeOptions: [
                {
                    val: 'JINGZU',
                    label: '经租',
                },
                {
                    val: 'RONGZU',
                    label: '融租',
                },
            ],
            subjection_type: '',
            imageObj: {},
            purposeConfig: {
                type: 'purpose',
                typeText: 'purposeText',
                val: 'OTHER',
            },
            ruleForm: {},
            rules: {
                licensePlateNumber: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' },
                    { min: 7, max: 8, message: '车牌号为7位或者8位', trigger: 'blur' },
                    {
                        pattern: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5,6}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4,5})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
                        message: '车牌号格式不正确',
                        trigger: 'blur',
                    },
                ],
                vehicleIdentificationNumber: [
                    { required: true, message: '请输入车架号', trigger: 'blur' },
                ],
                engineNumber: [
                    { required: true, message: '请输入发动机号', trigger: 'blur' },
                ],
                vehicleModel: [
                    { required: true, message: '请输入车辆型号', trigger: 'blur' },
                    { max: 80, message: '最多输入80个字符', trigger: 'blur' },
                ],
                powered: [
                    { required: true, message: '请选择油电性质', trigger: 'change' },
                ],
                // color: [
                //   { required: true, message: '请选择颜色', trigger: 'change' }],
                purpose: [
                    { required: true, message: '请选择车辆用途', trigger: 'change' },
                ],
                remark: [{ max: 100, message: '最多输入100个字', trigger: 'blur' }],
                operator: [{ validator: checkName, trigger: 'blur' }],
            },
            imageConfig: {
                url: '/proxy/vehicle/file/file/upload',
                imageList: [
                    {
                        limit: 4,
                        title: '车辆照片',
                        key: 'vehiclePhotos',
                        span: 16,
                        fileList: [],
                    },
                    {
                        limit: 1,
                        title: '网约车证',
                        key: 'onlineLicensePhotos',
                        span: 8,
                        fileList: [],
                    },
                    {
                        limit: 2,
                        title: '行驶证照片',
                        key: 'drivingLicensePhotos',
                        span: 16,
                        fileList: [],
                    },
                ],
            },
        };
    },
    computed: __assign({}, mapState('vehicle', [
        'vehicleDetail',
        'vehicleOperatorList',
        'companyList',
    ]), mapState('info', ['signCompanyList'])),
    methods: {
        submitForm: function () {
            var _this = this;
            // 提交表单信息
            this.$refs.ruleForm.validate(function (valid) {
                if (valid) {
                    _this.$refs.imageUpload.forEach(function (item) {
                        var key = item.imageObj.key;
                        _this.imageObj[key] = item._data.uploadKeys.join(',');
                    });
                    var params = __assign({}, _this.ruleForm, _this.imageObj);
                    _this.$request({
                        url: '/proxy/vehicle/driver/vehicle/upload/single',
                        method: 'post',
                        data: params,
                    }).then(function (res) {
                        if (!res.errorCode) {
                            _this.$confirm('', '', {
                                message: "<p class=\"title\">\u8F66\u8F86\u5355\u4E2A\u5BFC\u5165\u6210\u529F</p><p class=\"text\">\u53EF\u524D\u5F80\u8F66\u8F86\u7BA1\u7406-\u8F66\u8F86\u67E5\u8BE2-\u67E5\u770B</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '前往查看',
                                cancelButtonText: '取消',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                _this.$router.push({
                                    path: '/console/vehicle/query',
                                });
                            })
                                .catch(function () {
                                _this.changeBtnName = '取消';
                                _this.ruleForm = {};
                                eventBus.$emit('removeImage');
                            });
                        }
                        else {
                            _this.$message.error(res.errorMsg);
                        }
                    });
                }
                else {
                    return false;
                }
            });
        },
        changeRadioValue: function () {
            this.ruleForm = Object.assign({}, this.ruleForm, { subjection: '' });
        },
    },
});
